<template>
  <div class="padding-10 border-without-color" :style="getCreditAssessmentLogBackgroundStyle">

    <weex-text class="font-size-base" :style="getCreditAssessmentLogTextStyle">
      {{ getCreditAssessmentLogDescription }}
    </weex-text>

  </div>
</template>

<script>


import { Constants, SeverityLevel } from "@/components/Constants";

  export default {
    name: "CreditAssessmentLogSummaryAdapter",
    props: {
      creditAssessmentLog: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },

    methods: {

    },

    computed: {

      getCreditAssessmentLogDescription() {
        if (this.creditAssessmentLog && this.creditAssessmentLog["description"]) {
          return this.creditAssessmentLog["description"];
        }

        return "";
      },

      getSeverityLevelDetails() {
        if (this.creditAssessmentLog) {
          return Constants.getSeverityLevelDetails(this.creditAssessmentLog["severity"]);
        }

        return SeverityLevel.DEFAULT;
      },

      getCreditAssessmentLogBackgroundStyle() {
        const backgroundStyle = {};

        const severityLevelDetails = this.getSeverityLevelDetails;
        if (severityLevelDetails) {
          backgroundStyle["background-color"] = severityLevelDetails.backgroundColor;
          backgroundStyle["border-color"] = severityLevelDetails.borderColor;
        }

        return backgroundStyle;
      },

      getCreditAssessmentLogTextStyle() {
        const textStyle = {};

        const severityLevelDetails = this.getSeverityLevelDetails;
        if (severityLevelDetails) {
          textStyle["color"] = severityLevelDetails.textColor;
        }

        return textStyle;
      },
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

